module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.04238b54.woff2";